import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { TAGE } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/tage';
import { useTranslation } from 'react-i18next';
import { Title, Toggle } from '@e2n/ui/v2';
import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';

export function TageSelect() {
  const form = useAnlageassistentFormContext();
  const { t } = useTranslation();

  const options = Object.entries(TAGE).map(([key, value]) => ({
    value,
    label: t(`general.date.days.${key}Short`),
  }));
  return (
    <div className="flex flex-col gap-4">
      <Title>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.arbeitstage.description',
        )}
      </Title>

      <form.AppField name="bezahlung.arbeitszeitkonto.arbeitstage">
        {(field) => (
          <FieldBase
            label={t(
              'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.arbeitstage.label',
            )}
            isRequired>
            <div className="flex gap-2">
              {options.map((option) => (
                <Toggle
                  key={option.value}
                  value={option.value}
                  onPressedChange={(pressed) => {
                    if (pressed) {
                      field.handleChange([...field.state.value, option.value]);
                    } else {
                      field.handleChange(
                        field.state.value.filter(
                          (value: number) => value !== Number(option.value),
                        ),
                      );
                    }
                  }}
                  pressed={field.state.value.includes(option.value)}>
                  {option.label}
                </Toggle>
              ))}
            </div>
          </FieldBase>
        )}
      </form.AppField>
    </div>
  );
}
